import * as React from 'react';
import { AboutUsBody, AboutUsHeader } from './styled';
import VerticalSpacer from '../VerticalSpacer';
import withCountryCode from '../../components/RoutesHoc/RoutesHoc';
import { faq, howToShop, linkedIn, returnsPolicy } from '../../helpers/routes';
import Link from '../Link/Link';

const AboutUsLearnMore: React.ComponentType<{
  buildUrlWithCountry: (route: string) => string;
}> = ({ buildUrlWithCountry }) => (
  <div>
    <AboutUsHeader>Learn more</AboutUsHeader>
    <VerticalSpacer height="10px" />
    <AboutUsBody>
      Due to our unique model and innovative approach, we recommend that you read our{' '}
      <Link href={buildUrlWithCountry(howToShop)}>How to Shop</Link> section thoroughly before you make a purchase.
      <br />
      <br />
      Remember, you’re importing luxury goods directly from Italy, so your returns are processed through Italian
      customs. This process requires additional shipping costs and customs duties, which is why we don’t offer free
      returns at this time. Please read our <Link href={buildUrlWithCountry(returnsPolicy)}>Returns Policy</Link> for
      more details.
      <br />
      <br />
      Read more about us on <Link href={linkedIn}>LinkedIn</Link>.
      <br />
      <br />
      Still have questions? Please read our <Link href={buildUrlWithCountry(faq)}>FAQ</Link> section.
    </AboutUsBody>
  </div>
);

export default withCountryCode(AboutUsLearnMore);
